import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`IBM Cloud Pak for Integration brings together IBM’s market-leading
middleware capabilities to support a broad range of integration styles
and use cases. With powerful deployment, lifecycle management, and
production services running on Red Hat OpenShift, it enables clients to
leverage the latest agile integration practices, simplify the management
of their integration architecture, and reduce cost. In this document you
request access to a shared Cloud Pak for Integrations on ROKS, to be used in
Sales Demos. The environment is pre-installed with demo assets, and you just
need to follow the Demo Script. Remember, this is a shared environment, please
don’t customize or change anything there. If you need your own environment,
follow the directions from `}<a parentName="p" {...{
        "href": "/cp4i-demohub/cp4i-on-roks/"
      }}>{`Request your own CP4I environment on ROKS`}</a>{`.`}</p>
    <p>{`You will complete the following high level tasks:`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Requesting Access to the shared Environment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessing the Environment</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Requesting Access to the shared Environment`}</h2>
    <p>{`1.Access the `}<a parentName="p" {...{
        "href": "https://assetrepo.ibm.com/collection/cloud-pak-outcomes"
      }}>{`Cloud Pak Outcomes`}</a>{` collection on IBM Asset Repo and log in using your IBM credentials.`}</p>
    <p>{`2.On the Outcomes Environments, click on the `}<strong parentName="p">{`Environments`}</strong>{` section (1) and select `}<strong parentName="p">{`Cloud Pak for Integration - Outcomes`}</strong>{` (2).`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABlElEQVQoz5VSTY+bMBDlD+aQSOmtm/+7l0qVethqs9CFZY1JABPABmxen71JulEObUd6Gns88+bL0deHB2y3W6zXa2w2m6terVb/jC39vxC73Q7RaAy8LB7LEmCtDfp/xUdExfMzhvccy5l4mibUdQ2t9ZXcOQdLzMOAoZQYjgeY6ghNfYUsMLcKkUwS9FLw0gZCQ6KEtjzPIaXE4XAIuu06nJg4eXrCr/0eIktRvGUosgyK5HUSQ78miMw43pRtjEYcx0jTNBCVZYmiKCBJXJMkZbI93wVtJW0ePmmlFMZCIMKn2XkZpxlVraDo4FtvmgYNde01KxJCQsgy3BW7aoi6oT87GMU7ogvZhdCMFrXSoXV9xsDZaXbSsWLxwhbZusrfbuCTmTy7rzCcnb2xXbfo7/OEZfqA+wTLhI4LvG+ZD0q150/ArdOp9wGXd+swOfIuF48/2ssdYactvscaUtngeeR3+sF5ViT1IrsR+WmG6GYm86wfcUcuxs/9jrAdHB5/Gnx7MahO7u+f+RzX9z00Z/0bRvkuAG8IuicAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes cp4i",
          "title": "outcomes cp4i",
          "src": "/cp4i-demohub/static/3f940e14818a3062e32248774d3f45a9/3cbba/outcomes-cp4i.png",
          "srcSet": ["/cp4i-demohub/static/3f940e14818a3062e32248774d3f45a9/7fc1e/outcomes-cp4i.png 288w", "/cp4i-demohub/static/3f940e14818a3062e32248774d3f45a9/a5df1/outcomes-cp4i.png 576w", "/cp4i-demohub/static/3f940e14818a3062e32248774d3f45a9/3cbba/outcomes-cp4i.png 1152w", "/cp4i-demohub/static/3f940e14818a3062e32248774d3f45a9/91a72/outcomes-cp4i.png 1440w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`3.Select your `}<em parentName="p">{`Reservation type`}</em>{`.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.416666666666664%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0ElEQVQoz52STW9SURCGj59p1KgJKSXAtbRpgwXTCK21iBiNWxM/Y9L/QoFiJFpMo7GJ9gaN0Y2Lhp/BD4AFC1ZsWJgQxcK99H49Xm5oIIi26SRzzpx3znln3skRidgqq7HbzMzMMjs3z9VgkOhiiGh4nvBCEK/fj8c9ieTzEZoLcHNlmVvxONFIxMbdSK5LBKanCYQjLEhTCMnjIXRtEZ/XS2JliYd3lnh69zqJsB9p8jJXplxcPHOSU0JwPxZl7fkznjx+RCIe48LpE5xzuZmI3OPsjQecDy4jkqk068kULzIZ3ubzvN98zc5Wju3NHNn1JNtvXvFyI002k+bbJxn54wfebeUdLJfNsLHzldSXXTKF76Q+7yKwzbBwzLBd1cHk+CYURaHTaWNZfVb6u302DQPLNDFtN+zY7MemaThnXddRuvv8+PmbVltxcqJUKiHLMsVikUKhQLVapV6vo6pqn9ca644im2Bf0/m112FPUR1cNBoNyuUytVqNSqVCs9mk1Wo51Q8Ih4mHMc2+07aJuprmxA7h/+YxGMO/cz2Zarc7IOwtg9mYf8kaRzqc773RhtSIUUlH9dFiB7g4TNphNlpEGIZ5rA7Hddz7Zn8AJtoyjRnVW+YAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes reservation type",
          "title": "outcomes reservation type",
          "src": "/cp4i-demohub/static/375ff63e0a111ea3ab9c516f56b5840e/3cbba/outcomes-reservation-type.png",
          "srcSet": ["/cp4i-demohub/static/375ff63e0a111ea3ab9c516f56b5840e/7fc1e/outcomes-reservation-type.png 288w", "/cp4i-demohub/static/375ff63e0a111ea3ab9c516f56b5840e/a5df1/outcomes-reservation-type.png 576w", "/cp4i-demohub/static/375ff63e0a111ea3ab9c516f56b5840e/3cbba/outcomes-reservation-type.png 1152w", "/cp4i-demohub/static/375ff63e0a111ea3ab9c516f56b5840e/b8d10/outcomes-reservation-type.png 1434w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`4.Follow the `}<strong parentName="p">{`Create a reservation`}</strong>{` form to define the details of your ROKS Reservation.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "61.45833333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB9UlEQVQoz5WS7UpbQRCGF8GiQku1qaBJNFXTJqnRBrTRYPMB/S0WfxR6QZoPMRgJgoVaEWzxl0npJeQqcgOeiKGenM1JTvbk7c7GU0JL0zrwsLOzs+/Ozi6Lr0WxEU9hwe/H/IIfL0NBrLxaRHQ5gHDoOWZ8Pky6nsA9PYXgvA8b61EkkknEYuvwyJh74hGeed2YDa8i4POCTcnkF4EQvB4P1iJLeJd6je3EEt5G5jDjeoi56adwjQ1jiDHEloP48H4bW1ubSCXeYGLsAUYfj2MkksRwdBOj4ThYOpPDzk4auXQGR4VDHB8WcFLM41PxALndrIwVUNjfR3o3g69npzg7PcHHoyLye1kcSPKfz5G5+I6980tkv3wDw2/WvaN/fh9jhtGApl2hVtNwfV2Drt+CYk3OJQbMphwlXPqcc4VhGDLWhOgImG0LtR8GbnQOYdtglmWpRRqJNtFuQwgBWyYI0YP8frrdroqbMlfnJm4ltowx2uycSLRaLYVpmgPpHWqDmy0lSoUoQdpcr9flVXWVSJX9L6rHUqQpNaxOR/mqwkajoaD+0NypchCUR0Z9IzFHXFVIYnRdurrTeKp2kCD1mwR+/QbpK8E/vo1qtug9EPXmL9A67kT6hVm1WkWpVEKlUkG5XAbNNU1TVf7LHCEanYf8CWaqMQlrvfPzAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes create reservation",
          "title": "outcomes create reservation",
          "src": "/cp4i-demohub/static/5dbc964729cb20d606d46a6356b6a7cd/3cbba/outcomes-create-reservation.png",
          "srcSet": ["/cp4i-demohub/static/5dbc964729cb20d606d46a6356b6a7cd/7fc1e/outcomes-create-reservation.png 288w", "/cp4i-demohub/static/5dbc964729cb20d606d46a6356b6a7cd/a5df1/outcomes-create-reservation.png 576w", "/cp4i-demohub/static/5dbc964729cb20d606d46a6356b6a7cd/3cbba/outcomes-create-reservation.png 1152w", "/cp4i-demohub/static/5dbc964729cb20d606d46a6356b6a7cd/7df4c/outcomes-create-reservation.png 1414w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`5.After few seconds, your Cloud Pak for Integration Outcomes Demonstration is ready.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.76388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACB0lEQVQoz5WS32tSYRjHz2BFxKhoaMs501YTXTHNWtNm1EVXQUTrIvafpMccFKWrCbUtWBG7imAX3Xa5/oi6WNBuolW6pWeeczzq0U/vqzDMFmwPfHnO+7zf5/v8eI8yOTHB5egVfD4fp4fP4PePED4fJDx6lmBgBJfbzYDTwdDgIIFhL+MXI0RjMcKhkIg7Geo/iveUB28wRMB9AsVzcoDRc2O4XS7i4xFuxSNMXRsjHnTjcRzD4zzOkQM99CoKN2IXmL53l6k7t7k6GaWvt4fD/Q4Oha5z8NJN+vwRlPtJlUQiyYyaIpfJsPD0CUu5x8xnH5FOJHg+m+FhOo2aUFlaXGThxTzPsllmUqqIqzx4uUzyzQqpV29Jvl5BQZjdYE9m74GjlEolNja+o+s69XqdWq1K1TKxKiYVU0B4y6pgmoY4GyJewTB0wbGo2zamVeNnUUczLBqNBoqmaRQKBQxdQyvm2dra5Ee+yK98AU0rIQtKjoRuCNGWoCEK14RAE6tW53fZZNu02h1KsS9ra6x/0/j0tczndZ3NUl0kV9odC0hv2/8OXBXxslkRorUWT3KU1dWP5OZmWf6wzcw7mHsPZnX3/TSbzb8gTY5pivGleGvkrpQddCd3inR+20JEdrfzKPJCKjdantZe2uT/i3YKd3evdF/s17qLKLK73fazX7T2KX7oP832LrtKlQ21AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes ready",
          "title": "outcomes ready",
          "src": "/cp4i-demohub/static/247a936051b2912a258418c71cf67d92/3cbba/outcomes-ready.png",
          "srcSet": ["/cp4i-demohub/static/247a936051b2912a258418c71cf67d92/7fc1e/outcomes-ready.png 288w", "/cp4i-demohub/static/247a936051b2912a258418c71cf67d92/a5df1/outcomes-ready.png 576w", "/cp4i-demohub/static/247a936051b2912a258418c71cf67d92/3cbba/outcomes-ready.png 1152w", "/cp4i-demohub/static/247a936051b2912a258418c71cf67d92/b8d10/outcomes-ready.png 1434w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <hr></hr>
    <h2>{`Accessing the Environment`}</h2>
    <p>{`1.Check, your email. You should have received two emails, one from IBM Cloud and the second one from APIC Administrator. Let’s start with the IBM Cloud’s email (next section you will use the APIC Administrator’s email). In this first email, you should have the Environment URL, login and password (take note of them, you will use them multiple times during the demo). Open the `}<strong parentName="p">{`URL`}</strong>{`.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "952px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.29166666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzUlEQVQoz3WR30uTURjHvUjIuel073z3Szfd3KZbKZSlgShhlLG6CLyru7qXLMoLbYoFkklUJIG4QiH8A0TS8scRtfmzwCTBLZ3z1/Y2pyC03Hm/nb1G6EUHHr6ch+f5nO/znKTW1lbo9To4HIUoKLAzdcBszkPt3Qe4Wu1CxU0PWtoGUd/chce1XlSVXkNd/UNcvlINk8kEp9Mp9dlsVtjtNiQ1NjYgOfkEeD4LajXHlIdSqYRKxYHjVLAXu3DryQAuuFfhLGuBVWtBBpcBNZfFalTQaDRSn0qVKdUnNTW5IZOlwGDQM6d6aPlM2EpuoNJ1B2pVOrJZ3lVzGxdr7iHPbIFCoYDFYkHd/QZk5xgZkJcmTKhWq0GS2+1GSspJ6HQ6ltAy1cKUZ0OhoxicWg0dKzbnGVFoNUkjWa1WFBUVoarqErsXIDc3l/Xx0oQJ6BGg9hDIXuH1PHIKzjJoBXI0einf19eP+fl5TE9Pw+v9jNHRUYRCIXg8HsjlqVL/MeChbQ4WeylOV7pgLz2PQss5lJRfh7O8DB8/DGBmdgZTU15MTEzA5/MhcXp7e5GaKvsfkEeaIgNpBgNM+aeQoz8DGWeCSp0p9vf3i5OTkxgbI+L4+LgoCILIeGJPT7f416H4D5j4lMRCjSYjnj5rQ8frV+h848Hbrm68fNEudnR0YNnnE4WfghgKhxOBbRaJ8545lKfKxKMOKQNStlRqy7fQiG+ZxrbDdDcQoHtrQforvEMPhAiNrgZEwb8iRv1+uutfjgtL3+PxjWC8q72NKtLTKNs9ZUD6zyHPHOYbsxH8toCd/RhCQhSb4R0sLgfgD2xgfX2Lbm6F6U4kGqcHccRivyWH7563Q66QH9shYUDCa3iSb84lP0Y+kf2FL2Tv6yyJzE2RNTJE1saGycrQ4BCL4eDYyEhkbpqEZrwkvrRIOpsfEYUynTCHhAHJH3yt1O+eN4MPAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes email",
          "title": "outcomes email",
          "src": "/cp4i-demohub/static/5b0c23cb9123eed0faf7e4752cd3ab94/f26e3/outcomes-email.png",
          "srcSet": ["/cp4i-demohub/static/5b0c23cb9123eed0faf7e4752cd3ab94/7fc1e/outcomes-email.png 288w", "/cp4i-demohub/static/5b0c23cb9123eed0faf7e4752cd3ab94/a5df1/outcomes-email.png 576w", "/cp4i-demohub/static/5b0c23cb9123eed0faf7e4752cd3ab94/f26e3/outcomes-email.png 952w"],
          "sizes": "(max-width: 952px) 100vw, 952px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`2.If necessary, accept the risks. On the `}<em parentName="p">{`Log in`}</em>{` page, click on `}<strong parentName="p">{`Enterprise LDAP`}</strong>{` link.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.72222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVQoz5WTa06DQBSFu4hCQSmhwjyBFpBaEkOq0R8mJroA97+O452hNEzaaPlxcueR+XLunJmFlBJCCJh6TeMe5xxBEMD3fXieh+VyaauZr1arc12MhwbReAIaZecjkJQkCdIss3WEOUBHE8hUjICHJAaP10jTFIIxbDYbC7lwKKWyICk4pMqR58VpjROcQdHYtByRuwM5OxY1moyT2/A6UPCMQCXyuoduP5E3z4OzfAdd7i3YAH06EIZ3iOMHRFGC8H592TJnGbqXD9TdG3TzSu40iqqFEhn0tkPRfUEp45A5ofi+54DOQHNfj/sntP03FLlRkmNXVSi2NXR1hGreySFzUh7bnMppmbOUYOSK7kaQE6ELlP0PFAGF1NS+mAccAmBDKKeADNiAbFhKzQX+r1nA6SN2Hrm4/lNuAs75en8BfwGqTk5qfoJcSgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes login",
          "title": "outcomes login",
          "src": "/cp4i-demohub/static/04d59565853db826b3e644a5f3a69fb6/3cbba/outcomes-login.png",
          "srcSet": ["/cp4i-demohub/static/04d59565853db826b3e644a5f3a69fb6/7fc1e/outcomes-login.png 288w", "/cp4i-demohub/static/04d59565853db826b3e644a5f3a69fb6/a5df1/outcomes-login.png 576w", "/cp4i-demohub/static/04d59565853db826b3e644a5f3a69fb6/3cbba/outcomes-login.png 1152w", "/cp4i-demohub/static/04d59565853db826b3e644a5f3a69fb6/b8d10/outcomes-login.png 1434w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`3.Log in, using the username and password that you received in your email.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.416666666666664%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABoElEQVQoz31T207CQBDtJ2hiL9KyLdC906UFogZiYow+aEx8MP6mv3icXWgDCD6c7Ganc+bMzGmklIKUEv48hz4mhECWZUiSJCCO43CmaRrQ36M+acABUY9DwpRQVhWmdQ1WVoiJ6GZfZCA8ghRnFXtCnzBjY8wFR0PfWV5DTirwshyURsdEHNq2mDcOSuvdm6gprgfC1WyKjmINkTkidlTcv+W+7YGQEpVdwK6eYdZv0N02kCi7hFls6C4GwpbPqKCBNgbGWvpmjobaz33bnlBQpYenN6w2rzDtI6yWcN0KSkyh3R3m9x9BbZghJeiKg4k1xuUEjDHkrISkMQwK/by6rsX68RPGPUArasMt0Cy3MMtn6OULdcAhpEIWX6Frv6Dff1AxizK5xphIbD5C4R3Qt+xVKuOoDbebm7awm29SuN2No19KlqLKC9SkbsYmmBZjVLcZ4TaoP1gKzUvJPXZ3SbPqyQ5tc7O3ySlObHPO2PqPbYIPk3SwyCl8PDoy9T/gnIek/g+5hKhpGhiygCUL/AdNmy6KAqPR6CL81n8B+6VTq0HwDx0AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "outcomes username",
          "title": "outcomes username",
          "src": "/cp4i-demohub/static/23445d0595b51ff8c6991ceeb9590899/3cbba/outcomes-username.png",
          "srcSet": ["/cp4i-demohub/static/23445d0595b51ff8c6991ceeb9590899/7fc1e/outcomes-username.png 288w", "/cp4i-demohub/static/23445d0595b51ff8c6991ceeb9590899/a5df1/outcomes-username.png 576w", "/cp4i-demohub/static/23445d0595b51ff8c6991ceeb9590899/3cbba/outcomes-username.png 1152w", "/cp4i-demohub/static/23445d0595b51ff8c6991ceeb9590899/b8d10/outcomes-username.png 1434w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <hr></hr>
    <h2>{`Accepting the Invitation for API Provider Organizations`}</h2>
    <p>{`1.As part of the demo, you will need to access the Demo API Provider Organization in IBM API Connect. You should have received an email from APIC Administrator to joint the Demo Organization. Open this email, and click the link to accept the invitation.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "840px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.94444444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB30lEQVQoz2WS626bQBCFef/XSRNbKmmk/kzVyFJbjLFdE+7ggLnswi4YTmfX2HXVlT7O7DBXgSGEQFVVYIxp6rpG0zRaFWVZar+KucYp/ziOmKZJQw9IKTWGSvA8D1EUIc9znaAKXlUV4ZzfGilbqS4IqjVrXrcoGw6jp6rn8xnqXLv9d+5802wrHSlP3caWY+p77TfkMIC1LVoq3EoBQS94191Q9zMlDzSJajuoNe+bdRzy7fV2NVia4oNWLvyA1EdOegpC5GSfwhAszdBQzF8y1AlpkoAVJ+TfXlGs3tBXJQbCCFc/YNkebOsAe+1qLGvWXy7Ws+3ufMTvIUKXOASISGNlezHSKAOLQgj3N4xk72N9lHBSjm3Wkbawkxa7Y6d1m11sh3RPqmL0neI2xCHvUIoJtRjR0dRG7BxgxQybsIIT1bCDCuvgYt98pFcsv9SaVR3yRqAguBhQsw4d/SlGsnX1dIekxja6oIrsYqXVPz7/yODNpKcWH1T0SJyYBOMCQxrThDsPPzNJ43O9wprWdGgtr+zhFhLvhDsT1QNSdtbEzYBkJu8mNHJEn6X0UUwT9sMTnE8LbB4WcB4X2D4usX9aIjI/I3t5RvLFvPBsIp65t/OvLyjMJdjqO/4AbhY6EtlDzLAAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "api org invitation",
          "title": "api org invitation",
          "src": "/cp4i-demohub/static/07f8fba0a80129639eebc2fb692795bc/a6874/api-org-invitation.png",
          "srcSet": ["/cp4i-demohub/static/07f8fba0a80129639eebc2fb692795bc/7fc1e/api-org-invitation.png 288w", "/cp4i-demohub/static/07f8fba0a80129639eebc2fb692795bc/a5df1/api-org-invitation.png 576w", "/cp4i-demohub/static/07f8fba0a80129639eebc2fb692795bc/a6874/api-org-invitation.png 840w"],
          "sizes": "(max-width: 840px) 100vw, 840px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`Select the `}<strong parentName="p">{`LDAP User Registry for Outcomes`}</strong>{` authentication type.`}</p>
        <span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.47222222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz42SW2sTURSF8++U3JC8RPruo6iIvvgHRFBQpE+Cv8CA0icfREoJXhALlUJMGkhNYxp7m3OZmTOZmc9z5hJax0I3s5iZPfusWXuvXet2u3Q6Her1Oo1Go4Jms0m73abVav0X7lvT1t26d4eba2vUhBBIKVFKVeDyURRxlUjimCRJqFWJ5OoH5wlTrhY5oRQIIfGEJVEarV1O4tQbY3LCNK0gSRwgtncHl6sdzn+z8f4TQWg4nB/wfWfIaLLg5EyuFMaxO5CrdAQOecQWS5cterCEw9Een/ub/JzFfBuc4p0uGI33GexN0Va9MRFaHqG8ua3Xq4NWELv7EV8HAT8mKbtTCCNLGPqSj9uC1x98vgx8lqHK2heel83TEW7tGN5sat71fXpbga1LMEHE7SfHXL9/xrW7J9x4cMz0j51hGCi2h4rZQhIbS3TOcdeysS33+vD8LaxvwLMe2bvRAeuvxjx6Mefh0xmPX044EpYwm1Mo8f1c2WUul62WfidBQPJrXMxvWcyzcFlIdYHk3z10JiytMSXsRWrdj7XOjUpzZC5fttSVPSzXpXgu4+IqwV/wgSGAA8IWlQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "apic ldap",
            "title": "apic ldap",
            "src": "/cp4i-demohub/static/f9afc29ea586ee2089605314b51a14da/3cbba/apic-ldap.png",
            "srcSet": ["/cp4i-demohub/static/f9afc29ea586ee2089605314b51a14da/7fc1e/apic-ldap.png 288w", "/cp4i-demohub/static/f9afc29ea586ee2089605314b51a14da/a5df1/apic-ldap.png 576w", "/cp4i-demohub/static/f9afc29ea586ee2089605314b51a14da/3cbba/apic-ldap.png 1152w", "/cp4i-demohub/static/f9afc29ea586ee2089605314b51a14da/02b27/apic-ldap.png 1423w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </li>
    </ol>
    <p>{`3.Log in, using the username and password.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.81944444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB00lEQVQoz3WSv2/TQBTH/acxJ06GLEHdGSuEVMTI3JUKFqTCyljBQgeEKgQtEqKiQiIkRXJL09h1Y/t+2s75vrxzmiip6UlfnfTO/tx79/16/X4fvV4PrVYL7Xa7Id/30e120el0/it35tN3Dx49xP2NDXiMMXDOIYRoyNXLsoRb1lrcXq60qFfGoKoqeE0QX16wClxCbgErkqnmcmsO5AyMcWSMIEJCSlfjcN07oJSK6gKGunAUS53UNOREFLSbm6ssvHByiXf7h9B5gXByge8nQ4yCCNOULztkBIviGEJK6sje/ArsfTHY2Zvh+dsKu+8thCbgcHSKo88H+D02+DZIkCURRn/OMDj9W49dFgXi4BzR2RjxRYjo/BLpOIRRCo93gXtPbC3/qcVVSsBccXw8Znj1QeHrQGGWi3p8lqX1mKXWuA4CTBMGLXMoVUClDIbOfwTAwYnFp58Wh78s8tIBtcDxUGAccZiCQCuOL4BZdI1UGTBZIqOdMwVD7960iUyp3ynndPO8s4XLtQg40wov38TY3NHYeiGx+Uxj+3UGw1I4Y42x5PBcLkK1y4yLtais5ZDekF8lSCZTUlIrC6c0TbHM52pGvbtCfVcO14PdDPs/mTkgKpO5EbwAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "apic login",
          "title": "apic login",
          "src": "/cp4i-demohub/static/d4a075cd717e22ae7b952a92f6c902b6/3cbba/apic-login.png",
          "srcSet": ["/cp4i-demohub/static/d4a075cd717e22ae7b952a92f6c902b6/7fc1e/apic-login.png 288w", "/cp4i-demohub/static/d4a075cd717e22ae7b952a92f6c902b6/a5df1/apic-login.png 576w", "/cp4i-demohub/static/d4a075cd717e22ae7b952a92f6c902b6/3cbba/apic-login.png 1152w", "/cp4i-demohub/static/d4a075cd717e22ae7b952a92f6c902b6/7ea17/apic-login.png 1420w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`4.Now you should see a `}<strong parentName="p">{`Registration completed successfully`}</strong>{` screen. Great, you are ready to demo!`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.47222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVQoz3WSTWtTQRSG7x+rC6ulzdci0mTjugru/BcGNyIuBMEfELIJBcGFSBdFhcSCq5hEq3jvzUfTe+983Y9M8nbONMamNw68zHBm5jnvOTNOvV5HtVpFoVBAsVjMqVQqoVKpoFwub4hi+wf7uL+3h3u7u3j4+AgPDg/hMMbAOYcQIieKZ1mG20NrbednL5/jroHVajXc2dlBo9GAkwfxdYKbQILMghBCKiyXSxvrdDtoNptot9totVrodrsrIGdgjCNiBiIkpKQYB7lP03QNvJjNMBqPEYShTbZtOOORj+P3nxAnKcYjF1+/9TH4NcFlyDcckqvpdArf8+AZ+b6P0IApKSUjLRYLOP3BEJ9PT/Dd0+j0AkTBBIMfv9Eb/rHl/wXSYQJIKRHHMZRSVkmSrBOSnERxfDxjePtB4UtPYZ4IWz6LopxDcuW6rnF6Ycsnd8K0aBMYC5z1BbwJh04N6MaL54Cei+Ggj/Pzn6ZsF9JUoKRcdW8FtJcSs6Gunf3vlekw9XUyDezMRGIeUUGqWyXTRcbFBmT7P1zgzbsUT15pPH09N8rw6EWG9mlq3ZkW/3O47VNvcyiURsjnCIVGJGitoRK92r8+cwVknhi+rVls8wAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "apic registration",
          "title": "apic registration",
          "src": "/cp4i-demohub/static/fd288323376f8a0a140bb46b894b52e1/3cbba/apic-registration.png",
          "srcSet": ["/cp4i-demohub/static/fd288323376f8a0a140bb46b894b52e1/7fc1e/apic-registration.png 288w", "/cp4i-demohub/static/fd288323376f8a0a140bb46b894b52e1/a5df1/apic-registration.png 576w", "/cp4i-demohub/static/fd288323376f8a0a140bb46b894b52e1/3cbba/apic-registration.png 1152w", "/cp4i-demohub/static/fd288323376f8a0a140bb46b894b52e1/30331/apic-registration.png 1424w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      